import { ApiClient } from "client/base";
export class CloudSchemaMonitorClient extends ApiClient {
    setCredentials(id, request) {
        return this.base.post(`v1/schema_monitor/${id}/credentials`, request);
    }
    getCredentials(id) {
        return this.base.get(`v1/schema_monitor/${id}/credentials`).then((creds) => {
            if (creds["db_schema"] !== undefined) {
                creds["schema"] = creds["db_schema"];
                delete creds["db_schema"];
            }
            return creds;
        });
    }
    updateCredentials(id, request) {
        return this.base.patch(`v1/schema_monitor/${id}/credentials`, request);
    }
}
